import React, { useState } from 'react'
import { firestore } from '../../firebase';

function AddRente() {

    const [bank, setBank] = useState("");
    const [renteType, setRenteType] = useState("");
    const [renteProsent, setRenteProsent] = useState(0);

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    async function submitHandler(e) {
        e.preventDefault();

        try {
            const renteRef = firestore.collection("renter");
            const data = {
                bank,
                rente_type: renteType,
                rente: renteProsent
            }
            renteRef.add(data);
            setMessage("Lagt til!");
        } catch (error) {
            setError("Kunne ikke legge til")
        }

    }

    return (
        <form onSubmit={submitHandler} className="my-2">
            <label>Bank</label>
            <input className="form-control mb-2" value={bank} onChange={e => setBank(e.target.value)} />

            <label>Rente Type</label>
            <input className="form-control mb-2" value={renteType} onChange={e => setRenteType(e.target.value)} />

            <label>Rente {renteProsent} %</label>
            <input type="range" className="form-control mb-2" value={renteProsent} onChange={e => setRenteProsent(e.target.value)} max="20" step="0.01" />

            {error && <div className="alert alert-danger">{error}</div>}
            {message && <div className="alert alert-success">{message}</div>}
            <button className="btn btn-block btn-success">Lagre endringer </button>
        </form>
    )

}
export default AddRente